"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountNetworkInfo = exports.avoidDups = void 0;
const flow_1 = __importDefault(require("lodash/flow"));
const bignumber_js_1 = require("bignumber.js");
const wallet_btc_1 = require("./wallet-btc");
const speeds = ["fast", "medium", "slow"];
function avoidDups(nums) {
    nums = nums.slice(0);
    for (let i = nums.length - 2; i >= 0; i--) {
        if (nums[i + 1].gte(nums[i])) {
            nums[i] = nums[i + 1].plus(1);
        }
    }
    return nums;
}
exports.avoidDups = avoidDups;
function getAccountNetworkInfo(account) {
    return __awaiter(this, void 0, void 0, function* () {
        const walletAccount = (0, wallet_btc_1.getWalletAccount)(account);
        const rawFees = yield walletAccount.xpub.explorer.getFees();
        const relayFee = yield walletAccount.xpub.explorer.getRelayFee();
        // Convoluted logic to convert from:
        // { "2": 2435, "3": 1241, "6": 1009, "last_updated": 1627973170 }
        // to:
        // { 2435, 1241, 1009 }
        const feesPerByte = (0, flow_1.default)([
            // Remove the 'last_updated' key
            Object.entries,
            entries => entries.filter(([key]) => !isNaN(key)),
            // Reconstruct the array with only the values
            Object.fromEntries,
            Object.values,
            // Safety against invalid data
            f => f.filter(f => f != null && typeof f === "number"),
            // Normalize values
            f => f.map(f => new bignumber_js_1.BigNumber(f).div(1000).integerValue(bignumber_js_1.BigNumber.ROUND_CEIL)),
            avoidDups,
        ])(rawFees);
        if (feesPerByte.length !== 3) {
            throw new Error("cardinality of feesPerByte should be exactly 3");
        }
        // Fix fees if suggested fee is too low, this is only for viacoin/decred because the fees backend endpoint is broken
        if ((account.currency.id === "viacoin" ||
            account.currency.id === "decred" ||
            account.currency.id === "qtum") &&
            feesPerByte[2].toNumber() < Math.ceil(relayFee * 100000)) {
            feesPerByte[2] = new bignumber_js_1.BigNumber(Math.ceil(relayFee * 100000)).plus(2);
            feesPerByte[1] = feesPerByte[2].plus(1);
            if (feesPerByte[1].plus(1).gt(feesPerByte[0])) {
                feesPerByte[0] = feesPerByte[1].plus(1);
            }
        }
        const feeItems = {
            items: feesPerByte.map((feePerByte, i) => ({
                key: String(i),
                speed: speeds[i],
                feePerByte,
            })),
            defaultFeePerByte: feesPerByte[Math.floor(feesPerByte.length / 2)] || new bignumber_js_1.BigNumber(0),
            relayFee,
        };
        return {
            family: "bitcoin",
            feeItems,
        };
    });
}
exports.getAccountNetworkInfo = getAccountNetworkInfo;
//# sourceMappingURL=getAccountNetworkInfo.js.map